import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import type { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { dataGridLocaleRu, tablePaginationRu, dataGridLocaleEs, tablePaginationEs } from '../i18n/dataGridLocale';

interface DataTableProps {
  rows: GridRowsProp;
  columns: GridColDef[];
  loading?: boolean;
  pageSize?: number;
  onRowDoubleClick?: (row: any) => void;
  onRowClick?: (row: any) => void;
}

const DataTable: React.FC<DataTableProps> = ({ rows, columns, loading = false, pageSize = 10, onRowDoubleClick, onRowClick }) => {
  const { i18n } = useTranslation();
  
  const localeText = React.useMemo(() => {
    if (i18n.language === 'ru') {
      return {
        ...dataGridLocaleRu,
        MuiTablePagination: tablePaginationRu,
      };
    }
    if (i18n.language === 'es') {
      return {
        ...dataGridLocaleEs,
        MuiTablePagination: tablePaginationEs,
      };
    }
    return undefined;
  }, [i18n.language]);

  return (
    <div style={{ height: 600, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        pageSizeOptions={[pageSize, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize } } }}
        localeText={localeText}
        showToolbar
        onRowDoubleClick={(params) => onRowDoubleClick && onRowDoubleClick(params.row)}
        onRowClick={(params) => onRowClick && onRowClick(params.row)}
      />
    </div>
  );
};

export default DataTable; 